<template>
  <div class="row">
    <div class="col s10">
      <span v-if="filteredLogs.length === 0" style="margin: 15px">{{ $t('events.noComments') }}</span>
      <table class="logs" v-else>
        <thead>
          <tr>
            <th class="date">{{ $t('logbook.date') }} </th>
            <th>{{ $t('logbook.message') }}</th>
            <th class="user">{{ $t('logbook.user') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(log, index) of filteredLogs" :key="index">
            <td class="log">
              {{ formatDate(log.dateTime) }}
            </td>
            <td class="log">
              {{ log.message }}
            </td>
            <td class="log">
              {{ log.name }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col s2">
      <button class="waves-effect waves-light btn buttonbg right" style="margin: 15px;" @click="openModal" v-show="showButton==true">
        {{ $t('events.addComment') }}
      </button>
      <Modal name="add-comment">
        <div style="padding: 15px;">
          <div class="row">
            <div class="col s8">
              <strong>{{ $t('events.addCommentToMeasurement') }} {{ activeMeasurement ? measurementDateTime : '' }}</strong>
            </div>
            <div class="col s3">
              {{ today }}
            </div>
            <div class="col s1">
              <a @click="closeModal" style="cursor: pointer;">
                <i class="material-icons">
                  close
                </i>
              </a>
            </div>
          </div>
          <div class="row">
            <div class="col s12">
              <label>
                <input type="text" v-model="newItem" :placeholder="$t('events.comment')" />
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col s12">
              <button
                type="button"
                class="right waves-effect waves-light btn buttonbg"
                @click="addItem"
              >
                {{ $t('events.add') }}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  </div>
</template>
<script>
import switchApi from '../../services/api/switch/SwitchApi'
import moment from 'moment'
import AuthenticationService from '../../services/AuthenticationService'

export default {
  name: 'MeasurementComments',
  props: {
    switchObject: {
      type: Object,
      required: false,
      default: null
    },
    activeMeasurement: {
      type: Object,
      required: false,
      default: null
    },
    lastselectedMeasurement: {
      type: Object,
      required: false,
      default: null
    },
    selectedMeasurementIds: {
      required: false,
      default: () => []
    }
  },
  data () {
    return {
      logs: [],
      newItem: ''
    }
  },
  computed: {
    showButton () {
      if (this.switchObject) {
        if (this.switchObject.ParentRailObjectId !== null) {
          return true
        }
      }
      return false
    },
    filteredLogs () {
      // this.getLogs()
      var selectedlogs = []
      if (this.selectedMeasurementIds.length > 0) {
        this.selectedMeasurementIds.forEach((x) => {
          this.logs.forEach((y) => {
            if (x.id === y.measurementId && y.measurementId !== null) {
              if (!selectedlogs.includes(y)) {
                selectedlogs.push(y)
              }
            }
          })
        })
      }
      return selectedlogs
    },
    today: function () {
      return moment().format('DD-MM-YYYY, HH:mm')
    },
    measurementDateTime () {
      return moment(this.lastselectedMeasurement.MeasurementDateTime).format('DD-MM-YYYY HH:mm:ss')
    }
  },
  watch: {
    lastselectedMeasurement () {
      this.getLogs()
    },
    activeMeasurement () {
      this.getLogs()
    },
    switchObject () {
      this.getLogs()
    }
  },
  methods: {
    openModal () {
      this.$modal.show('add-comment')
    },
    closeModal () {
      this.$modal.hide('add-comment')
    },
    formatDate: (dateTime) => {
      const s = dateTime + ''
      const year = s.substring(0, 4)
      const month = s.substring(5, 7)
      const day = s.substring(8, 10)
      const hour = s.substring(11, 13)
      const minute = s.substring(14, 16)
      const second = s.substring(17, 19)
      return `${day}-${month}-${year}, ${hour}:${minute}:${second}`
    },
    getLogs () {
      if (this.switchObject) {
        switchApi.getLogBook(this.switchObject.RailObjectId)
          .then(result => {
            this.logs = result.data
          })
      }
    },
    async addItem () {
      if (this.lastselectedMeasurement) {
        const user = await AuthenticationService.getUser()
        const dto = {
          logbook: {
            Code: 1,
            RailObjectId: this.switchObject.RailObjectId,
            PossObjectCodeId: this.switchObject.PossObjectCodeId,
            Comment: this.newItem,
            CommentDateTime: moment().toISOString(true),
            MeasurementId: this.lastselectedMeasurement.MeasurementId
          },
          userId: user.UserId,
          userName: user.UserName
        }
        this.closeModal()
        await switchApi.insertLogBookItem(dto)
        this.getLogs()

        this.$emit('comment-added', {
          measurementId: this.lastselectedMeasurement.MeasurementId,
          comment: this.newItem
        })

        this.newItem = ''
      }
    }
  }
}
</script>
<style scoped>
  table.highlight tbody tr:hover {
    background-color: #eee !important;
  }

  .logs td.log {
    padding: 2px 5px;
    vertical-align: top;
  }

  .logs .date {
    width: 15%;
  }

  .logs .user {
    width: 15%;
  }

  .buttonbg {
    background: #56CCF2;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.24), 0px 0px 2px rgba(0, 0, 0, 0.12);
    border-radius: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/switch/MeasurementComments.vue